import { ChangeEvent, useState } from "react";
import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import Loader from "../Loader";
import { ParseErrors } from "../../utils/ParseErrors";
import OtpForm from "./otp-form";

interface TLoginForm {
  HandleFlip: () => void;
}

const Loginform = ({ HandleFlip }: TLoginForm) => {
  const [showOtp, setShowOtp] = useState(false);
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleRequestOtp = async () => {
    if (!values.email) {
      toast.error("Please enter a valid email");
      return;
    }
    if (!values.password) {
      toast.error("Please enter a valid password");
      return;
    }

    setIsLoading(true);
    try {
      const res = await axiosInstance.post("/auth/login", values);

      if (res.data?.requiresOtp) {
        setShowOtp(true);
        toast.success("Verification code sent to your email");
      }
    } catch (error) {
      toast.error(ParseErrors(error));
    } finally {
      setIsLoading(false);
    }
  };

  const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  if (showOtp) {
    return (
      <OtpForm
        password={values.password}
        onBack={() => setShowOtp(false)}
      />
    );
  }

  return (
    <div className="absolute inset-0 rounded-2xl border border-[#E4EBF5] bg-white px-5 py-8 shadow-[0_20px_50px_rgba(21,44,85,0.08)] [backface-visibility:hidden] sm:px-10 sm:py-10">
      <div className="mb-8 text-center">
        <h2 className="font-[Gilroy-Bold] text-[28px] text-[#152C55]">
          Sign in
        </h2>
        <p className="mt-2 font-[Gilroy-Medium] text-[14px] text-[#6B7C99]">
          Enter your credentials to continue
        </p>
      </div>

      <div className="space-y-5">
        <CustomInput
          title="Email"
          label="Email"
          name="email"
          type="email"
          value={values.email}
          onChange={onChangeValues}
          className="!h-[48px] !rounded-xl !border-[#E4EBF5] !bg-[#F7F9FC] focus:!border-[#1562EE] focus:!bg-white"
        />
        <CustomInput
          title="Password"
          label="Password"
          name="password"
          type="password"
          value={values.password}
          onChange={onChangeValues}
          className="!h-[48px] !rounded-xl !border-[#E4EBF5] !bg-[#F7F9FC] focus:!border-[#1562EE] focus:!bg-white"
        />

        <p
          className="cursor-pointer text-right font-[Gilroy-Medium] text-[14px] text-[#1562EE] transition-colors hover:text-[#0F4FBF]"
          onClick={HandleFlip}
        >
          Forgot Password?
        </p>

        <CustomButton
          variant="primary"
          fullWidth
          onClick={handleRequestOtp}
          disabled={isLoading}
          className="!mt-2 !h-[50px] !rounded-xl !border-none !bg-[#1562EE] !text-[15px] !font-[Gilroy-Medium] hover:!bg-[#1254CC]"
        >
          {isLoading ? <Loader /> : "Continue"}
        </CustomButton>
      </div>
    </div>
  );
};

export default Loginform;
